export default function ArrowRight({ className = '' }) {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_9944_7282)">
        <path
          d="M10.11 13.2002L15.11 8.20011M15.11 8.20011L10.11 3.20019M15.11 8.20011L1.10999 8.2001"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_9944_7282">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0.109985 0.200195)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
